import { FC } from 'react';
import Image from 'next/image';
import { Text } from '@mofid-securities/uikit';
import clsx from 'clsx';
import { Icon } from '@/components/atomic/Icon';
import { FundCoverBackground } from './components/FundCoverBackground';
import { FundCoverSkeleton } from './components/FundCoverSkeleton';
import { useGetFundCodeFromQuery } from '@/modules/invest/hooks/useGetFundCodeFromQuery';
import { useGetFundDetails } from '@/modules/invest/subModules/fund/hooks/useGetFundDetails';
import { useGetFundsInformation } from '@/modules/invest/subModules/fund/hooks/useGetFundsInformation';
import { generateEfficiencyForChip } from '@/modules/invest/utils/generateEfficiencyForChip';

interface IFundCoverProps {}

export const FundCover: FC<IFundCoverProps> = ({}) => {
  const fundCode = useGetFundCodeFromQuery();

  const { fundDetails } = useGetFundDetails(fundCode);
  const { isLoading } = useGetFundsInformation();

  if (isLoading) {
    return <FundCoverSkeleton />;
  }

  const { formattedEfficiency, icon, textColorClass } =
    generateEfficiencyForChip(fundDetails?.return1D || 0);

  return (
    <>
      {fundDetails && (
        <div className="relative flex w-full flex-col items-center justify-center gap-y-3 p-4">
          <FundCoverBackground />
          <Image
            alt={fundDetails.title}
            className="rounded-full"
            height={56}
            src={fundDetails.logo}
            width={56}
          />
          <div className="flex gap-x-1">
            <Text
              className="text-gray-filled-primary-enabled"
              component="h1"
              size="sm"
              weight="medium"
            >
              صندوق {fundDetails.title}
            </Text>
            <div className="items-center rounded-lg bg-neutral-filled-primary-enabled px-2 py-0.5 text-xxs text-gray-filled-primary-enabled">
              {fundDetails.fundCategory.name}
            </div>
          </div>
          <div className="flex items-center gap-x-0.5">
            <Text
              className="text-gray-filled-tertiary-enabled"
              size="xs"
              weight="medium"
            >
              بازدهی روزانه:
            </Text>
            <Text
              className={clsx(textColorClass, 'ltr')}
              size="xs"
              weight="medium"
            >
              {formattedEfficiency}
            </Text>
            {icon && <Icon className={textColorClass} icon={icon} />}
          </div>
        </div>
      )}
    </>
  );
};
